export default __webpack_public_path__ + "static/media/expert-kraver.48690b4e.svg";